import { snapRoundDecimal } from '@calculations/round/decimal';
import {
  perQuantityFromSiteUnits,
  siteUnits,
} from '@calculations/utilities/selling-uom';

import { onPartUnitCostChange } from '../../calculations/recalculate';
import { validateUnitCost } from '../../validations/unit-cost';
import { PriceFieldHandlerParams } from './types';

export function handlePartUnitCostChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
  priceStrategyConfigs,
}: PriceFieldHandlerParams) {
  const enteredUnitCost = validateUnitCost(state, {
    unitCost: value,
    quoteLineUuid,
    quotePriceUuid,
  });

  if (!enteredUnitCost) {
    return;
  }

  /**
   * Cost per selling unit in, cost per each stored — the same pairing as
   * `unitPrice`, and it has to move with it or margins stop reconciling.
   */
  const unitCost = perQuantityFromSiteUnits(
    siteUnits(snapRoundDecimal(enteredUnitCost)),
    { sellingUnitOfMeasure: state.sellingUnitOfMeasure },
  );

  onPartUnitCostChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    unitCost,
    priceStrategyConfigs,
  });
}

// @NOTE(mrs): Service charges do not have a unit cost
